import { AboutBoxComponent } from './../about-box/about-box.component';
import { DownloadStatus, DownloadFileStatus } from './../../model/DownloadStatus';
import { SoftwareInventoryService } from './../../service/software-inventory.service';
import { UserService } from 'src/app/service/user.service';
import { HeaderReconnectComponent } from './../header-reconnect/header-reconnect.component';
import { ModalRef } from './../controls/modal/modal-ref';
import { HeaderChangeEnvironmentComponent } from './../header-change-environment/header-change-environment.component';
import { HeaderProfileComponent } from './../header-profile/header-profile.component';
import { Modal } from '../controls/modal/modal.service';
import { ActivatedRoute, Router } from '@angular/router';
import { LoginState } from './../../model/LoginState';
import { Environment } from './../../model/SolutionInfo';
import { UserInfo, UserRole } from './../../model/User';
import { Component, OnInit, HostListener, ElementRef, Renderer2 } from '@angular/core';
import { AuthenticationService } from '../../service/authentication.service';
import { EventService } from '../../service/event.service';
import { Subscription, of } from 'rxjs';
import { Events, MsgPayLoad } from '../../service/websocket.service';
import { SolutionInfo } from '../../model/SolutionInfo';
import { AboutPageTab } from '../about-box/about-box.component';
import { MessageBanner, MessageBannerType } from '../controls/message-banner/message-banner.component';
import { FormGroup } from '@angular/forms';
import { catchError, finalize, tap } from 'rxjs/operators';
import { Utils } from 'src/app/utils';
import { EnableComponentComponent } from '../dialogs/enable-component/enable-component.component';
import { ProductDiscoveryComponent } from '../dialogs/product-discovery/product-discovery.component';
import { ActivityService } from 'src/app/service/activity.service';
import { NotificationPanelComponent } from '../dialogs/notification-panel/notification-panel.component';
import { SystemUpdateState, SystemUpdateStates } from 'src/app/model/SystemUpdateState';
import { ModalMessageComponent, ModalMessageType } from '../controls/modal-message/modal-message.component';
import { SolutionService } from 'src/app/service/solution.service';
import OTHHUrlBuilderConstructor from '@ghs/othhjs';

enum HeaderActivityType { ACTIVITY, DEPLOYMENT, MANIFEST }

class HeaderActivity {
  name: string;
  desc: string;
  type: HeaderActivityType;
  url: string;
}

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.css', '../../app.component.css'],
    standalone: false
})
export class HeaderComponent implements OnInit {

  //UI menu flags
  showUserMenu: boolean = false;
  showHelpMenu: boolean = false;
  showApiMenu: boolean = false;

  //download
  showDownloadHeaderBarMessage: boolean = false;
  showDownloadHeaderBarMessageDetail: boolean = true;
  isActiveDownloadButton: boolean = false;
  downloadStatusHandle: any = 0;
  downloadStatus: DownloadStatus = new DownloadStatus();

  //activity
  showActivityHeaderBarMessage: boolean = false;
  showActivityHeaderBarMessageDetail: boolean = true;
  isActiveActivityButton: boolean = false;
  activities: Map<HeaderActivityType, HeaderActivity> = new Map();
  actvitityTitle: string;
  HeaderActivityType = HeaderActivityType;

  //about box
  AboutPageTab = AboutPageTab;
  //help
  onlineHelpLink: string;
  forThisPageHelpLink: string;
  defaultHelpUrl: string;

  //reconnect modal
  reconnectModalRef: ModalRef;

  //subscription
  solutionInfoSubscription: Subscription;
  eventMessageSubscription: Subscription;
  systemUpdateStateSubscription: Subscription;
  helpURLSubscription: Subscription;

  solutionInfo: SolutionInfo = new SolutionInfo();
  currentUserAuthInfo: UserInfo;
  currentUserExtraInfo: UserInfo;
  messages: MessageBanner[] = [];
  messageMaxSize: number = 5;
  version: string;
  brandVersion: string;
  readonly messageDeleteTimeout: number = 5000;
  processUpdateBanner: boolean = false;
  processChangeDBPwdBanner: boolean = false;
  processNTLMDeprecationBanner: boolean = false;
  systemUpdateState: SystemUpdateState;
  notificationCount: string = "0";
  notificationCountTitle: string;
  actionUnavailableMessage: string = $localize`This action is unavailable during the upgrade process.`;

  constructor(private eleRef: ElementRef,
    private authService: AuthenticationService,
    private eventService: EventService,
    private activatedRoute: ActivatedRoute,
    private modal: Modal,
    private userService: UserService,
    private siService: SoftwareInventoryService,
    private router: Router,
    private renderer: Renderer2,
    private activityService: ActivityService,
    private solutionService: SolutionService) {

    this.eventMessageSubscription = this.eventService.eventMessage$.subscribe(msg => {
      if (msg.eventType == Events.AgentStatusOffline) {
        this.addMessageBanner(new MessageBanner(MessageBannerType.WARNING, $localize`${msg.body.name}:systemName: is offline.`));
      } else if (msg.eventType == Events.AgentStatusOnline) {
        this.addMessageBanner(new MessageBanner(MessageBannerType.INFO, $localize`${msg.body.systemName}:systemName: is online.`));
      } else if (msg.eventType == Events.ManagerConnected) {
        if (this.reconnectModalRef) {
          this.reconnectModalRef.close();
          this.reconnectModalRef = undefined;
        }
      } else if (msg.eventType == Events.ManagerDisconnected) {
        this.reconnectModalRef = this.modal.open(HeaderReconnectComponent, {
          data: {},
          id: 'otsc-header-reconnect-dialog'
        });
      } else if (msg.eventType == Events.SettingsConnectionMode) {
        this.currentUserAuthInfo.settings.isOnlineMode = msg.body.onlineMode;
        this.currentUserAuthInfo.settings.proxyPrompt = msg.body.proxyPrompt;
        this.authService.updateLoggedInUser(this.currentUserAuthInfo);
        this.addMessageBanner(new MessageBanner(MessageBannerType.INFO, msg.body.onlineMode ? $localize`Connection mode is changed to online.` :
          $localize`Connection mode is changed to offline.`));
      } else if (msg.eventType == Events.DownloadStarted) {
        this.getDownloadStatusStart();
      } else if (msg.eventType == Events.ServerError) {
        this.addMessageBanner(new MessageBanner(MessageBannerType.ERROR, msg.body.message, msg.body.link), true);
      } else if (msg.eventType == Events.SuccessMsg) {
        this.addMessageBanner(new MessageBanner(MessageBannerType.SUCCESS, msg.body.message, msg.body.link));
      } else if (msg.eventType == Events.InfoMsg) {
        this.addMessageBanner(new MessageBanner(MessageBannerType.INFO, msg.body.message, msg.body.link));
      } else if (msg.eventType == Events.ErrorMsg) {
        this.addMessageBanner(new MessageBanner(MessageBannerType.ERROR, msg.body.message, msg.body.link), true);
      } else if (msg.eventType == Events.WarningMsg) {
        this.addMessageBanner(new MessageBanner(MessageBannerType.WARNING, msg.body.message, msg.body.link));
      } else if (msg.eventType == Events.SessionExpired) {
        this.logOut(LoginState.SessionTimedOut);
      } else if (msg.eventType == Events.DownloadCompleted) {
        //show download error
        if (msg.body.status === 'ERROR') {
          this.addMessageBanner(new MessageBanner(MessageBannerType.ERROR, $localize` Error downloading ${msg.body.name}, please try again later.`));
        }
      } else if (msg.eventType == Events.ManifestUpdateStarted) {
        this.removeManifestBanner();
        this.setManifestActivityStatus(true);
      } else if (msg.eventType == Events.ManifestUpdateComplete) {
        this.setManifestActivityStatus(false);

        if (msg.body) {
          if (msg.body.forced) {
            if (msg.body.required) {
              if (msg.body.success) {
                this.addMessageBanner(new MessageBanner(MessageBannerType.SUCCESS,
                  $localize`A manifest update has been successfully completed.`));
              } else {
                if (msg.body.error !== "") {
                  this.addMessageBanner(new MessageBanner(MessageBannerType.ERROR,
                    $localize`A manifest update has failed, please try again later. ` + Utils.getHTTPStatusErrorMsg(msg.body.error)
                  ));
                } else {
                  this.addMessageBanner(new MessageBanner(MessageBannerType.ERROR,
                    $localize`A manifest update has failed, please try again later.`));
                }
              }
            } else {
              if (msg.body.success) {
                this.addMessageBanner(new MessageBanner(MessageBannerType.INFO,
                  $localize`A manifest update has been completed, the current manifest is already up to date.`));
              } else {
                if (msg.body.error !== "") {
                  this.addMessageBanner(new MessageBanner(MessageBannerType.ERROR,
                    $localize`A manifest update has failed, please try again later. ` + Utils.getHTTPStatusErrorMsg(msg.body.error)
                  ));
                } else {
                  this.addMessageBanner(new MessageBanner(MessageBannerType.ERROR,
                    $localize`A manifest update has failed, please try again later.`));
                }
              }
            }
          } else {
            if (!msg.body.success) {
              if (msg.body.error !== "") {
                this.addMessageBanner(new MessageBanner(MessageBannerType.ERROR,
                  $localize`A manifest update has failed, please try again later. ` + Utils.getHTTPStatusErrorMsg(msg.body.error)
                ));
              } else {
                this.addMessageBanner(new MessageBanner(MessageBannerType.ERROR,
                  $localize`A manifest update has failed, please try again later.`));
              }
            }
          }
        }

      } else if (msg.eventType == Events.ActivityRefresh) {
        this.activityService.listActiveActivity().pipe(
          tap(resp => {
            this.setActivityStatus(resp.body.numActivity);
            this.setDeploymentActivityStatus(resp.body.numExecution);
          })
        ).subscribe();
      } else if (msg.eventType == Events.SystemUpdate) {
        this.addMessageBanner(new MessageBanner(MessageBannerType.WARNING, msg.body.message, msg.body.link), false, 15000);
      } else if (msg.eventType == Events.AgentManifestError){
        this.addMessageBanner(new MessageBanner(MessageBannerType.ERROR,
          $localize`System '${msg.body.hostname}' ( with MAC address: ${msg.body.macaddress} ) failed to successfully update it's manifest. Please check the logs for more information.`
        ), true);
      } else if (msg.eventType == Events.MandatoryManifestUpdate) {
        let manifestBannerMsg = new MessageBanner(MessageBannerType.ERROR, msg.body.message, msg.body.link);
        if (!this.isManifestBannerMessagePresent(manifestBannerMsg)){
          this.addMessageBanner(manifestBannerMsg, true, 0);
        }
      } else if (msg.eventType == Events.EnvChanged) {
        this.addMessageBanner(new MessageBanner(MessageBannerType.INFO, $localize`Your environment was changed to ${msg.body.solName}:solutionName: : ${msg.body.envName}:environmentName:.`));
      } else if (msg.eventType == Events.ChangeDefaultDBPassword) {
        this.addMessageBanner(new MessageBanner(MessageBannerType.WARNING, msg.body.message, msg.body.link), false, 15000);
      } else if (msg.eventType == Events.SettingsProxy) {
        this.addMessageBanner(new MessageBanner(MessageBannerType.ERROR, msg.body.message, msg.body.link), true, 0);
      }
    });

    this.solutionInfoSubscription = this.eventService.currentSolutionInfo$.subscribe(newSolutionInfo => {
      this.solutionInfo = newSolutionInfo;
      this.showApiMenu = this.solutionInfo.showApiMenu;
      let prodVer:String[] = this.solutionInfo.manifestStatus.currentVersion.split(".");
      if(prodVer.length > 2){
        this.version = `${prodVer[0]}.${prodVer[1]}.${prodVer[2]}`;
        this.brandVersion = `${prodVer[0]}.${prodVer[1]}`;
      }
      this.onlineHelpLink = this.getOnlineHelpURL(this.solutionInfo.settings.helpURL, 'top-of-doc');
      this.forThisPageHelpLink = this.getOnlineHelpURL(this.solutionInfo.settings.helpURL, this.getForThisPageHelpContextId(this.activatedRoute.root));
      this.defaultHelpUrl = this.solutionInfo.settings.defaultHelpURL;

      //download process
      if (this.solutionInfo.isDownloading) {
        this.getDownloadStatusStart();
      } else {
        this.getDownloadStatusStop();
      }

      //activity progress
      this.updateActivityProgress();

      if (!this.processUpdateBanner) {
        this.processUpdateBanner = true;
        if (Utils.isSystemUpdateRequired(this.solutionInfo)) {
          Utils.postSystemUpdateMessage(this.solutionInfo, this.eventService);
        }
      }
      if (this.solutionInfo.manifestStatus.mandatoryUpdateRequired){
        Utils.postManditoryManifestUpdateMessage(this.eventService);
      }
      let tmpCount = this.solutionInfo.notificationDetails.count += Utils.processSystemNotifications(this.solutionInfo, this.currentUserAuthInfo).length;
      this.notificationCount = (tmpCount > 99) ? "99+": tmpCount.toString();
      if(tmpCount == 1){
        this.notificationCountTitle = $localize`${tmpCount} new notification`;
      }else{
        this.notificationCountTitle = $localize`${tmpCount} new notifications`;
      }
      if (!this.processChangeDBPwdBanner) {
        this.processChangeDBPwdBanner = true;
        Utils.showChangeDefaultDatabasePasswordMessage(this.solutionInfo, this.eventService, this.currentUserAuthInfo);
      }

      if(!this.processNTLMDeprecationBanner) {
        this.processNTLMDeprecationBanner = true;
        Utils.showNTLMAuthDeprecationMessage(this.solutionInfo, this.eventService, this.currentUserAuthInfo);
      }
    });

    this.systemUpdateStateSubscription = this.eventService.systemUpdateState$.subscribe(newUpdateState => {
      this.systemUpdateState = (newUpdateState.state == SystemUpdateStates.Complete) ? undefined : newUpdateState;
    });

    this.helpURLSubscription = this.eventService.helpURL$.subscribe(newURL => {
      this.onlineHelpLink = this.getOnlineHelpURL(newURL, 'top-of-doc');
      this.forThisPageHelpLink = this.getOnlineHelpURL(newURL, this.getForThisPageHelpContextId(this.activatedRoute.root));
    });
  }

  ngOnInit(): void {
    this.currentUserAuthInfo = this.authService.getLoggedInUser();
  }

  ngOnDestroy() {
    this.solutionInfoSubscription.unsubscribe();
    this.eventMessageSubscription.unsubscribe();
    this.systemUpdateStateSubscription.unsubscribe();
    this.helpURLSubscription.unsubscribe();
  }

  //help
  getForThisPageHelpContextId(route: ActivatedRoute, helpContextId: string = ''): string {
    const children: ActivatedRoute[] = route.children;

    if (children.length == 0) {
      return helpContextId;
    }

    for (const child of children) {
      const helpContextId = child.snapshot.data['helpContextId'];

      return helpContextId ? this.getForThisPageHelpContextId(child, helpContextId) : '';
    }
  }

  //user
  getUserInitials(): string {
    let name: string = '';
    if(this.currentUserAuthInfo != undefined && this.currentUserAuthInfo.firstName != undefined){
      name = (this.currentUserAuthInfo.firstName == '' || this.currentUserAuthInfo.lastName == '') ?
      this.currentUserAuthInfo.userName.substring(0, 1) : this.currentUserAuthInfo.firstName.substring(0, 1) + this.currentUserAuthInfo.lastName.substring(0, 1);
    }
    return name;
  }

  //messages
  addMessageBanner(msg: MessageBanner, isPersistent: boolean = false, customTimeout: number = 0) {
    //remove the oldest message
    if (this.messages.length >= this.messageMaxSize) {
      this.removeMessageBanner(0);
    }

    let index: number = this.messages.length == 0 ? 0 : this.messages.length - 1;

    if (!isPersistent) {
      msg.timeout = setTimeout(() => {
        this.removeMessageBanner(index);
      }, (customTimeout > 0) ? customTimeout : this.messageDeleteTimeout);
    }

    this.messages.push(msg);
  }

  removeMessageBanner(index: number) {
    if (this.messages !== undefined && this.messages[index] !== undefined) {
      if (this.messages[index].timeout !== undefined) {
        clearTimeout(this.messages[index].timeout);
      }
      this.messages.splice(index, 1);
    }
  }

  handleMessageBannerLink(msg: MessageBanner): void {
    switch (msg.link.linkId) {
      case 'view_download_details':
        this.showDownloadHeaderBarMessage = true;
        break;
      case 'show-enable-details':
        Utils.currentModalRef = this.modal.open(EnableComponentComponent, {
          data: {
            enabledComponent: msg.link.data
          },
          id: 'otsc-enable-component-dialog',
          maxheight: '800px'
        });
        break;
      case 'discover-product-details':
        Utils.currentModalRef = this.modal.open(ProductDiscoveryComponent, {
          data: {
            name: msg.link.data.name,
            products: msg.link.data.products
          },
          id: 'otsc-product-discovery-dialog',
          maxheight: '800px'
        });
        break;
      case 'system-update':
        this.router.navigate(['/update']);
        break;
      case 'mandatory-manifest-update':
        this.router.navigate(['/settings/manifest']);
        break;
      case 'change-default-db-pwd':
        this.router.navigate(['/settings/database']);
        break;
      case 'settings-proxy':
        this.router.navigate(['/settings/proxy']);
        break;
    }
  }

  //user menu
  toggleUserMenu(): void {
    setTimeout(() => {
      this.showUserMenu = !this.showUserMenu;
    }, 0);
  }

  onKeyToggleUserMenu(event: KeyboardEvent): void {
    if (event.key === "Escape") {
      this.showUserMenu = false;
    }
  }

  //help menu
  toggleHelpMenu(): void {
    setTimeout(() => {
      this.showHelpMenu = !this.showHelpMenu;
    }, 0);
  }

  onKeyToggleHelpMenu(event: KeyboardEvent): void {
    if (event.key === "Escape") {
      this.showHelpMenu = false;
    }
  }

  onKey(event: KeyboardEvent):void {
    if(event.key === "ArrowUp" || event.key === "ArrowDown"){
      let menuElements:HTMLCollectionOf<Element> = (event.target as HTMLLIElement).parentElement.getElementsByClassName('ot-dropdown__item');
      let menuIndex:number = -1;

      //find the current menu index
      for (let index = 0; index < menuElements.length; index++) {
        if(menuElements.item(index) === (event.target as HTMLLIElement)){
          menuIndex = index;
          break;
        }
      }

      if(menuIndex > -1){
        if(event.key === "ArrowDown"){
          if(menuIndex + 1 <= menuElements.length - 1){
            (menuElements[menuIndex + 1] as HTMLLIElement).focus();
          }else{
            (menuElements[0] as HTMLLIElement).focus();
          }
        }else if(event.key === "ArrowUp"){
          if(menuIndex - 1 >= 0){
            (menuElements[menuIndex - 1] as HTMLLIElement).focus();
          }else{
            (menuElements[menuElements.length - 1] as HTMLLIElement).focus();
          }
        }
      }
    }else if(event.key === "Tab"){
      event.preventDefault();
    }
  }

  //help URL
  getOnlineHelpURL(urlRoot:string, contextId: string): string {
    let othh1: any = new OTHHUrlBuilderConstructor({
		urlRoot: urlRoot
	});

    let helpVersion: string = "";
    if (this.version) {
      let versionToken = this.version.split('.');
      if (versionToken.length > 1) {
        helpVersion = versionToken[0] + "0" + versionToken[1] + "00";
      }
    }

    return othh1.buildHelpUrl("en", {
      documents: [{
        module: "syscm-h-agd",
        version: helpVersion,
        topic: contextId
      }
      ]
    },
      {
        type: "ofh1",
        tenant: ""
      });
  }

  openForThisPageHelpLink(): void {
    this.showHelpNavigationWarning(this.forThisPageHelpLink);
  }

  openOnlineHelpLink(): void {
    this.showHelpNavigationWarning(this.onlineHelpLink);
  }

  showHelpNavigationWarning(helpUrl: string): void {
    let tmpUrl: URL = new URL(helpUrl);
    let defaultUrl: URL = new URL(this.defaultHelpUrl);
    if(tmpUrl.host == defaultUrl.host){
      window.open(helpUrl, "_blank");
    } else {
      const sub: Subscription =
      this.modal.open(ModalMessageComponent, {
        data: {
          title: $localize`Navigate`,
          message: $localize`You are about to navigate to an external site '${helpUrl}'.<br/>Do you wish to proceed?`,
          type: ModalMessageType.Question,
          primaryBtn: $localize`Yes`,
          secondaryBtn: $localize`No`,
          width: '450px'
        },
        id: 'otsc-help-navigation-warning'
      }
      ).afterClosed.subscribe((result: boolean) => {
        if (result) {
          window.open(helpUrl, "_blank");
        }
        sub.unsubscribe();
      });
    }
  }

  //API reference
  openAPIReferenceLink(): void {
    window.open('/services/v1/doc/', "_blank");
  }
  
  toggleShowAboutDialog(): void {
    this.showHelpMenu = false;
    this.modal.open(AboutBoxComponent, {
      data: {
        productVersion: this.version
      },
      id: 'otsc-about-dialog-modal',
      ariaLabelledBy: 'about-title',
    });
  }

  toggleShowProfileDialog(): void {

    let modalData = Utils.interuptUpgrade(this.systemUpdateState, true);
    if (modalData == undefined) {
      this.openProfileDialog();
    } else {
      modalData.data.message = this.actionUnavailableMessage;
      this.modal.open(ModalMessageComponent,
        modalData
      );
    }
  }

  openProfileDialog(): void {
    const sub: Subscription =
    this.modal.open(HeaderProfileComponent, {
      data: {
        currentUserAuthInfo: this.currentUserAuthInfo
      },
      id: 'otsc-header-profile-dialog'
    }
    ).afterClosed.subscribe((profileForm: FormGroup) => {
      if (profileForm) {
        const envList: number[] = [];
        const solList: string[] = [];
        const role: string = profileForm.get('userRoleCtrl').value;

        if (role === UserRole.SOLUTION_MANAGER.toString()) {
          if (profileForm.get('dataCtrl').value) {
            profileForm.get('dataCtrl').value.forEach(sol => {
              solList.push(sol.name);
            });
          }
        } else if (role === UserRole.ENVIRONMENT_MANAGER.toString()) {
          if (profileForm.get('dataCtrl').value) {
            profileForm.get('dataCtrl').value.forEach(env => {
              envList.push(env.id);
            });
          }
        }

        this.userService.updateUser(profileForm.get('userNameCtrl').value, //newUserName
          this.currentUserAuthInfo.userName,      //userName
          profileForm.get('givenNameCtrl').value, //firstName
          profileForm.get('surNameCtrl').value,   //lastName
          profileForm.get('newPasswordCtrl').value, //newPassword
          role, //role
          envList,
          solList,
          this.currentUserAuthInfo.userId).pipe(tap(resp => {
            if (resp) {
              //update logged in users
              this.currentUserAuthInfo.firstName = profileForm.get('givenNameCtrl').value;
              this.currentUserAuthInfo.lastName = profileForm.get('surNameCtrl').value;
              this.currentUserAuthInfo.role = role;
              this.authService.updateLoggedInUser(this.currentUserAuthInfo);
              this.addMessageBanner(new MessageBanner(MessageBannerType.INFO, $localize`Your profile was updated.`));
              let msg = new MsgPayLoad(undefined, {});
              msg.setEvent(Events.NotificationRefresh);
              msg.eventType = Events.NotificationRefresh;
              this.eventService.broadcastEventMessage(msg); //refresh
            }
          }),
            catchError(val => {
              this.addMessageBanner(new MessageBanner(MessageBannerType.ERROR, $localize`Error updating your profile. Please check the logs for more information.`));
              return of(val);
            })
          ).subscribe();
      }
      sub.unsubscribe();
    });
  }

  toggleChangeEnvironmentDialog(): void {

    let modalData = Utils.interuptUpgrade(this.systemUpdateState, true);
    if (modalData == undefined) {
      this.openChangeEnvironmentDlg();
    } else {
      modalData.data.message = this.actionUnavailableMessage;
      this.modal.open(ModalMessageComponent,
        modalData
      );
    }
  }

  openChangeEnvironmentDlg(): void {
    this.showUserMenu = false;
    const sub: Subscription =
      this.modal.open(HeaderChangeEnvironmentComponent, {
        data: {
          environments: this.solutionInfo.environments,
          currentEnvironment: this.solutionInfo.currentEnvironment
        },
        id: 'otsc-header-change-env-dialog',
        ariaLabelledBy: 'otsc-header-change-env-list-tile-header'
      }).afterClosed.subscribe((env: Environment) => {
        if (env) {
          const switchEnvProgress: ModalRef = this.modal.open(HeaderReconnectComponent, {
            data: { message: $localize`Switching environment, please wait...`},
            id: 'otsc-change-env-progress',
          });
          this.solutionService.switchEnvironment(env.id).pipe(
            tap(resp => {
              if(resp){
                this.currentUserAuthInfo = this.authService.getLoggedInUser();
                this.currentUserAuthInfo.settings.environmentId = env.id;
                this.currentUserAuthInfo.settings.solutionName = env.solName;
                this.authService.updateLoggedInUser(this.currentUserAuthInfo);
                this.eventService.broadcastLoginStateChange(LoginState.SignedIn);
                this.addMessageBanner(new MessageBanner(MessageBannerType.INFO, $localize`Your environment was changed to ${env.solName}:solutionName: : ${env.name}:environmentName:.`));
              }
            }),
            finalize(() => {
              switchEnvProgress.close();
            })).subscribe();
        }
        sub.unsubscribe();
      });
  }

  //download
  toggleDownloadHeaderBarMessage(): void {
    if (this.showActivityHeaderBarMessage) {
      this.showActivityHeaderBarMessage = false;
    }
    this.showDownloadHeaderBarMessage = !this.showDownloadHeaderBarMessage;
    if (this.showDownloadHeaderBarMessage) {
      setTimeout(() => {
        this.renderer.selectRootElement('#otsc-download-header-bar-close-btn', true).focus();
      }, 0);
    }
  }

  toggleDownloadHeaderBarMessageDetail(): void {
    this.showDownloadHeaderBarMessageDetail = !this.showDownloadHeaderBarMessageDetail;
  }

  getDownloadStatusStart(): void {
    this.isActiveDownloadButton = true;
    if (this.downloadStatusHandle === 0) {
      this.getDownloadStatus();
      this.downloadStatusHandle = setInterval(() => { this.getDownloadStatus(); }, 1000);
    }
  }

  getDownloadStatusStop(): void {
    this.isActiveDownloadButton = false;
    clearInterval(this.downloadStatusHandle);
    this.downloadStatusHandle = 0;
  }

  getDownloadStatus(): void {
    this.siService.getDownloadStatus().pipe(tap(resp => {
      if (this.downloadStatus.active.length > 0) {
        const newDownloadStatus = resp.body;
        if (newDownloadStatus.active.length == 0) {
          this.downloadStatus = resp.body;
        } else {
          this.downloadStatus.queue = newDownloadStatus.queue;
          this.downloadStatus.errors = newDownloadStatus.errors;

          this.downloadStatus.active.forEach((currentDFStatus: DownloadFileStatus, index: number) => {
            let foundDFStatus = newDownloadStatus.active.find(newDownloadFileStatus => newDownloadFileStatus.fileName === currentDFStatus.fileName);
            //update existing
            if (foundDFStatus) {
              currentDFStatus.downloadSize = foundDFStatus.downloadSize;
              currentDFStatus.percentage = foundDFStatus.percentage;
              currentDFStatus.totalSize = foundDFStatus.totalSize;
              currentDFStatus.status = foundDFStatus.status;
              currentDFStatus.totalSize = foundDFStatus.totalSize;
              currentDFStatus.type = foundDFStatus.type;
              //not found anymore which means the item was downloaded
            } else {
              this.downloadStatus.active.splice(index, 1);
            }
          });

          newDownloadStatus.active.forEach((newDownloadFileStatus: DownloadFileStatus) => {
            let foundDFStatus = this.downloadStatus.active.find(currentDFStatus => currentDFStatus.fileName === newDownloadFileStatus.fileName);

            //new items
            if (!foundDFStatus) {
              this.downloadStatus.active.push(newDownloadFileStatus);
            }
          });
        }
      } else {
        this.downloadStatus = resp.body;
      }

      if (this.downloadStatus.active.length == 0 && this.downloadStatus.queue == 0) {
        this.getDownloadStatusStop();
      }

      let msg = new MsgPayLoad(undefined, {});
      msg.setEvent(Events.DownloadStatus);
      msg.body = this.downloadStatus;
      this.eventService.broadcastEventMessage(msg);
    }),
      catchError(resp => {
        this.getDownloadStatusStop();
        return of(resp);
      })
    ).subscribe();
  }

  onKeyToggleDownloadMenu(event: KeyboardEvent): void {
    if (event.key === "Escape") {
      this.showDownloadHeaderBarMessage = false;
    }
  }

  logOut(newState?: LoginState): void {
    let modalData = Utils.interuptUpgrade(this.systemUpdateState);
    if (modalData == undefined) {
      this.getDownloadStatusStop();
      this.authService.logout(newState);
    } else {
      const sub: Subscription =
      this.modal.open(ModalMessageComponent,
        modalData
      ).afterClosed.subscribe((isPrimaryBtnClicked: boolean) => {
        if (isPrimaryBtnClicked) {

        } else {
          this.getDownloadStatusStop();
          this.authService.logout(newState);
        }
        sub.unsubscribe();
      });
    }
  }

  updateActivityProgress(): void {
    this.setActivityStatus(this.solutionInfo.activityInfo.activities.length);
    this.setDeploymentActivityStatus(this.solutionInfo.activityInfo.deployments.length);
    this.setManifestActivityStatus(this.solutionInfo.isUpdatingManifest);
  }

  setActivityTitle(): void {
    if (this.activities.size == 0) {
      this.isActiveActivityButton = false;
    } else {
      this.isActiveActivityButton = true;
    }

    this.actvitityTitle = this.getActivityOverviewText();
  }

  toggleActivityHeaderBarMessage(): void {
    if (this.showDownloadHeaderBarMessage) {
      this.showDownloadHeaderBarMessage = false;
    }
    this.showActivityHeaderBarMessage = !this.showActivityHeaderBarMessage;
    if (this.showActivityHeaderBarMessage) {
      setTimeout(() => {
        this.renderer.selectRootElement('#otsc-activity-header-bar-close-btn', true).focus();
      }, 0);
    }
  }

  toggleActivityHeaderBarMessageDetail(): void {
    this.showActivityHeaderBarMessageDetail = !this.showActivityHeaderBarMessageDetail;
  }

  setActivityStatus(numActivity: number) {
    if (numActivity == 0) {
      this.activities.delete(HeaderActivityType.ACTIVITY);
    } else {
      let desc: string = numActivity == 1 ? $localize`Running ${numActivity} activity. View details` :
        $localize`Running ${numActivity} activities. View details`;
      this.activities.set(HeaderActivityType.ACTIVITY, {
        name: $localize`Activity`,
        type: HeaderActivityType.ACTIVITY,
        desc: desc,
        url: '/activities/overview'
      });
    }

    this.setActivityTitle();
  }

  setDeploymentActivityStatus(numActivity: number) {
    if (numActivity == 0) {
      this.activities.delete(HeaderActivityType.DEPLOYMENT);
    } else {
      let desc: string = numActivity == 1 ? $localize`Running ${numActivity} execution plan. View details` :
        $localize`Running ${numActivity} execution plans. View details`;
      this.activities.set(HeaderActivityType.DEPLOYMENT, {
        name: $localize`Execution Plan`,
        type: HeaderActivityType.DEPLOYMENT,
        desc: desc,
        url: '/activities/executionplans'
      });
    }
    this.setActivityTitle();
  }

  setManifestActivityStatus(isActive: boolean) {
    if (!isActive) {
      this.activities.delete(HeaderActivityType.MANIFEST);
    } else {
      if (!this.activities.has(HeaderActivityType.MANIFEST)){
        this.activities.set(HeaderActivityType.MANIFEST, {
          name: $localize`Manifest Update`,
          type: HeaderActivityType.MANIFEST,
          desc: $localize`Updating manifest. View details`,
          url: '/settings/manifest'
        });
      }
    }
    this.setActivityTitle();
  }

  getActivityOverviewText() {
    let overviewText: string = "";

    if (this.activities.size == 0) {
      overviewText = $localize`No activities running`;
    } else if (this.activities.size == 1) {
      overviewText = $localize`Activity running`;
    } else {
      overviewText = $localize`Activities running`;
    }

    return overviewText;
  }

  @HostListener("document:click", [])
  clickout() {
    const hostElem = this.eleRef.nativeElement;
    if (hostElem.children[0].children[1]) {
      hostElem.children[0].children[1].classList.remove("ot-dropdown--is-active");
    }
    this.showUserMenu = false;
    this.showHelpMenu = false;
  }

  openNotificationPanel(): void {
    Utils.currentModalRef = this.modal.open(NotificationPanelComponent, {
      id: 'otsc-notification-panel-dialog',
      customclass: 'ot-modal-side-panel ot-modal-side-panel-sm',
      data: { currentUserAuthInfo: this.currentUserAuthInfo },
    });
  }

  isManifestBannerMessagePresent(banner: MessageBanner): boolean {
    let present = false;
    for(let i = 0; i < this.messages.length; i++){
      if (this.messages[i].link !== undefined && this.messages[i].link.linkId == 'mandatory-manifest-update'){
        present = true;
        break;
      }
    }
    return present;
  }

  removeManifestBanner(): void {
    for (let i = 0; i < this.messages.length; i++) {
      if (this.messages[i].link !== undefined && this.messages[i].link.linkId == 'mandatory-manifest-update') {
        this.messages.splice(i, 1);
        break;
      }
    }
  }
}
